import { strictObjectAccess } from '@ackee/redux-utils';

export const reportsGroups = strictObjectAccess({
    LIST: 'LIST',
});
